import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { Container, Typography, Box, Button, Paper, Alert } from '@mui/material';

export default function SkinsDebug({ tournamentId }) {
  const [tournament, setTournament] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTournament();
  }, [tournamentId]);

  const fetchTournament = async () => {
    try {
      console.log('=== SKINS DEBUG COMPONENT ===');
      console.log('Fetching tournament:', tournamentId);
      
      const tournamentDoc = await getDoc(doc(db, 'tournaments', tournamentId));
      if (tournamentDoc.exists()) {
        const data = tournamentDoc.data();
        console.log('Tournament data:', data);
        console.log('Scores:', data.scores);
        console.log('Skins config:', data.skins);
        setTournament({ id: tournamentDoc.id, ...data });
      } else {
        console.log('Tournament not found');
      }
    } catch (error) {
      console.error('Error fetching tournament:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Typography>Loading debug info...</Typography>;
  }

  if (!tournament) {
    return <Alert severity="error">Tournament not found</Alert>;
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom>Skins Debug Information</Typography>
      
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Tournament ID: {tournament.id}</Typography>
        <Typography variant="h6">Tournament Name: {tournament.name}</Typography>
      </Paper>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Scores Data:</Typography>
        <pre style={{ fontSize: '12px', overflow: 'auto', maxHeight: '200px' }}>
          {JSON.stringify(tournament.scores, null, 2)}
        </pre>
      </Paper>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Skins Config:</Typography>
        <pre style={{ fontSize: '12px', overflow: 'auto', maxHeight: '200px' }}>
          {JSON.stringify(tournament.skins, null, 2)}
        </pre>
      </Paper>

      <Button variant="contained" onClick={fetchTournament}>
        Refresh Data
      </Button>
    </Container>
  );
}
